<apm-section-title *ngIf="to.label" [title]="to.label" matTooltip="{{ canDebug ? field.key : '' }}"></apm-section-title>
<div class="d-flex flex-column mb-2" *ngFor="let image of field.fieldGroup">
  <span>{{ image.templateOptions?.label }}</span>
  <formly-field [field]="image"></formly-field>
</div>
